

import { Button } from '@/components/ui/button';
import { Loader2, LogOut } from 'lucide-react';

type SubmitButtonProps = {
  isLoading: boolean;
  onSignOut?: () => void;
};

export function SubmitButton({ isLoading, onSignOut }: SubmitButtonProps) {
  return (
    <div className="flex gap-4 justify-between items-center">
      <Button type="submit" disabled={isLoading}>
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Saving...
          </>
        ) : (
          "Save changes"
        )}
      </Button>
      
      {onSignOut && (
        <Button 
          type="button"
          variant="outline" 
          className="flex gap-2 items-center" 
          onClick={onSignOut}
        >
          <LogOut className="h-4 w-4" />
          Sign Out
        </Button>
      )}
    </div>
  );
}
